import { actionTypes } from 'app/types/action_types';

const initialState = {};

const mapPayload = (payload) => {
  if (Object.keys(payload).length === 0) return initialState;
  const { eoq } = payload;
  const value = {};
  if (eoq) value.eoq = eoq;

  return value;
};

// eslint-disable-next-line default-param-last
const homeHeroReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.INITIALIZE:
      return mapPayload(action.payload);
    default:
      return state;
  }
};

export default homeHeroReducer;
